<!-- List popup -->
<template>
	<div
		class="modal fade"
		id="listItemPopup"
		tabindex="-1"
		role="dialog"
		aria-labelledby="openModal"
		aria-hidden="true"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div
				class="modal-content campaign-g-addedit"
				style="width:1000px;height:260px;margin-left:-49px"
			>
				<div class="modal-header" style = "flex: 0 0 auto">
					<h5 class="modal-title" id="exampleModalLongTitle">{{type + (namesArray.length >1 ?'s':'') + ' linked to ' + clientName }}</h5>
					<button type="button" class="close" data-dismiss="modal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="showSpinner">
					<div class="spinner-border" style="margin:auto;display:block"></div>
				</div>

				<div class="modal-body" style="font-size:14px" v-else-if="!showSpinner && namesArray.length">
					<table class="table" v-if="type=='Vendor'||type=='vendor'">
						<thead>
							<tr>
								<th>Vendor Name</th>
								<th>Vc Alias</th>
								<th>Account Type</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in namesArray" :key="item +'_'+ index">
								<td width=35%>{{item.vendor_name}}</td>
								<td width=35%>{{item.vc_alias}}</td>
								<td>{{item.account_type}}</td>
							</tr>
						</tbody>
					</table>
					<table class="table" v-if="type=='Seller'||type=='seller'">
						<thead>
							<tr>
								<th>Merchant Name</th>
								<th>Merchant Id</th>
								<th>Country</th>
								<th >Auth Dev Token</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in namesArray" :key="item +'_'+ index">
								<td>{{item.merchant_name}}</td>
								<td>{{item.merchant_id}}</td>
								<td>{{item.country_code}}</td>
								<td width=25%>{{item.seller_dev_auth_token}}</td>
							</tr>
						</tbody>
					</table>
					<table class="table" v-if="type=='Profile'">
						<thead>
							<tr>
								<th ></th>
								<th width="14%">Brand Name</th>
								<th width="15%">Profile Type</th>
								<th>Seller/Vendor</th>
								<th width="25%">Market Camp Type</th>
								<th width="15%">Data Pull</th>
								<th>Budget($)</th>
								<th>Created On</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in namesArray" :key="item +'_'+ index">
								<td>
									<div
										style="width:14px;height:14px;border-radius:7px"
										:class="item.active ? 'show_green': 'show_red'"
									></div>
								</td>
								<td>{{item.customName}}</td>
								<td class="text-capitalize">{{item.profile_type}}</td>
								<td>{{getSellerOrVendorName(item)}}</td>
								<td>{{getCampType(item)}}</td>
								<td class="text-capitalize">{{item.data_pull}}</td>
								<td>{{formatDailyBudget(item.monthly_budget)}}</td>
								<td>{{formatDate(item.date_created)}}</td>
							</tr>
						</tbody>
					</table>
					<table class="table" v-if="type=='DSP'">
						<thead>
							<tr>
								<th>Advertiser Name | Account Agency</th>
								<th>Advertiser Id</th>
								<th>Entity Id</th>
								<th>Active</th>
								<th>Created On</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in namesArray" :key="item +'_'+ index">
								<td width="45%">{{item.advertiser_name + (item.accountagency ? ' | ' + item.accountagency : '')}}</td> 
								<td width="15%">{{item.advertiserId || ''}}</td>
								<td width="15%">{{item.accountinfo_id || ''}}</td>
								<td width="10%">{{item.active}}</td>
								<td width="15%">{{item.created_on ? formatDate(item.created_on) : ''}}</td>
							</tr>
						</tbody>
					</table>
					<table class="table" v-if="type=='AMC'">
						<thead>
							<tr>
								<th>Advertiser Name</th>
								<th>Instance Name</th>
								<th>Instance Id</th>
								<th>Active</th>
								<th>Created On</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in namesArray" :key="item +'_'+ index">
								<td width="20%">{{item.customer_canonical_name || ''}}</td> 
								<td width="15%">{{item.instance_name || ''}}</td>
								<td width="15%">{{item.instance_id || ''}}</td>
								<td width="15%">{{item.active ? 'True' : 'False' || ''}}</td>
								<td width="15%">{{item.creation_date ? formatDate(item.creation_date) : ''}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-body" v-else>
					<p class="ml-1">No items to display.</p>
				</div>
				<div class="modal-footer" style = "flex: 0 0 auto">
					<div style="text-align: center">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import moment from "moment";
const formatCurrency = require("format-currency");

	export default {
		name: "ListNamesPopUp",
		data() {
			return {};
		},
		components:{
			moment
		},
		props: ["namesArray", "type", "clientName", "showSpinner"],
		methods: {
			getSellerOrVendorName(item){
				if(item.profile_type=='seller'){
					return item.merchant_name
				}
				else if(item.profile_type=='vendor'){
					return (item.vendor||{}).vendor_name
				}
				else{
					return ''
				}

			},
			formatDailyBudget(num) {
				var num = formatCurrency(num);
				return num;
			},
			getCampType(item) {
				var arr = [];
				if (item.marketing_campaign_sb) {
					arr.push("SB");
				}
				if (item.marketing_campaign_sp) {
					arr.push("SP");
				}
				if (item.marketing_campaign_sd) {
					arr.push("SD");
				}
				if (item.marketing_campaign_st) {
					arr.push("ST");
				}
				return arr.join(", ");
			},
			// sellerOrVendor(item) {
			// 	if (item && item.profile_type_seller && item.profile_type_vendor) {
			// 		return "Seller, Vendor";
			// 	} else if (item && item.profile_type_seller) {
			// 		return "Seller";
			// 	} else if (item && item.profile_type_vendor) {
			// 		return "Vendor";
			// 	} else return "";
			// },
			openPopUp() {
				$("#listItemPopup").modal("show");
			},
			formatDate(data){
				return moment(data).format("MM/DD/YYYY");
			}
		}
	};
</script>

<style lang="scss">
.scroll {
	min-height: 350px !important;
	overflow: auto;
}
</style>
